import faviconCard from './manageFavicon/faviconCard'

export default {
  title: '',
  faviconCard
}
